import React from "react";
import { Configure, connectSearchBox } from "react-instantsearch-dom";
import Hits from "react-instantsearch-dom/dist/cjs/widgets/Hits";
import InstantSearch from "react-instantsearch-dom/dist/cjs/widgets/InstantSearch";
import RefinementList from "react-instantsearch-dom/dist/cjs/widgets/RefinementList";
import classnames from "classnames";
import PropTypes from "prop-types";

import { convertToCamelCase } from "utils/jsonFetch";

import { TypeaheadItem, TypeaheadMenu } from ".";

import styles from "./Typeahead.css";

const SearchBox = connectSearchBox(({ autoFocus, currentRefinement, onFocus, onInput, refine }) => (
  <input
    autoComplete="nope"
    autoFocus={autoFocus}
    onChange={(event) => refine(event.currentTarget.value)}
    onFocus={onFocus}
    onInput={onInput}
    type="search"
    value={currentRefinement}
  />
));

export default class Typeahead extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showHits: false };

    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleCollapse, false);
    document.addEventListener("touchend", this.handleCollapse, false);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleCollapse, false);
    document.removeEventListener("touchend", this.handleCollapse, false);
  }

  handleCollapse(event) {
    const el = this.container;
    if (el && !el.contains(event.target)) this.setState({ showHits: false });
  }

  handleFocus() {
    this.setState({ showHits: true });
  }

  handleSearch(event) {
    if (this.props.onInput) this.props.onInput(event.target.value);
  }

  handleSelect(hit) {
    this.setState({ showHits: false });
    this.props.onSelect(convertToCamelCase(hit));
  }

  render() {
    const { showHits } = this.state;
    const {
      facets,
      isChanged,
      isRequired,
      labelKey,
      placeholder,
      searchIndex,
      searchParameters,
      sublabelKey,
      value,
    } = this.props;

    const Item = ({ hit }) => (
      <TypeaheadItem
        label={labelKey ? labelKey.split(".").reduce((a, b) => a[b], hit) : hit.name}
        objectID={hit.objectID}
        onSelect={() => this.handleSelect(hit)}
        sublabel={sublabelKey ? sublabelKey.split(".").reduce((a, b) => a[b], hit) : ""}
      />
    );

    return (
      <div
        className={styles.wrapper}
        ref={(ref) => {
          this.container = ref;
        }}
      >
        <InstantSearch
          apiKey={algoliaAppKey}
          appId={algoliaAppId}
          indexName={searchIndex}
          searchState={{ query: value }}
          refresh
        >
          <Configure hitsPerPage={20} page={0} {...searchParameters} />

          {facets.map((f, i) => (
            <div key={i} style={{ display: "none" }}>
              <RefinementList
                attributeName={f.name}
                defaultRefinement={f.values.map((v) => v.toString())}
              />
            </div>
          ))}
          <div
            className={classnames(styles.search, {
              [styles.required]: isRequired,
              [styles.changed]: isChanged,
            })}
          >
            <SearchBox
              onFocus={this.handleFocus}
              onInput={this.handleSearch}
              translations={{ placeholder }}
              autofocus
            />
          </div>
          {showHits && !!value && (
            <TypeaheadMenu>
              <Hits hitComponent={Item} />
            </TypeaheadMenu>
          )}
        </InstantSearch>
      </div>
    );
  }
}

Typeahead.propTypes = {
  isChanged: PropTypes.bool,
  isRequired: PropTypes.bool,
  labelKey: PropTypes.string,
  sublabelKey: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  facets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      values: PropTypes.array,
    })
  ),
  searchIndex: PropTypes.string.isRequired,
  searchParameters: PropTypes.object, // eslint-disable-line
  onInput: PropTypes.func, // eslint-disable-line
  onSelect: PropTypes.func.isRequired, // eslint-disable-line
  value: PropTypes.string,
};

Typeahead.defaultProps = {
  placeholder: " ",
  facets: [],
};
